<template>
  <div class="min-height-for-section pb-4 w-100 pt-livetv ">
    <div class="container-fluid mb-4">
      <div class="row">
        <div class="col-12">
          <div class="w-100 d-flex align-items-center justify-content-center">
            <div class="login-wrapper p-md-4">
              <h2 class="modal-text">Sign Up</h2>
              <div class="w-100 mt-4">
                <!-- form -->
                <vue-form :state="formstate" @submit.prevent="onSubmit">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.name)"
                  >
                    <label class="w-100 text-gray text-left">Name</label>
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      required
                      v-model.lazy="model.name"
                    />

                    <field-messages
                      name="name"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Name is a required field
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.gender)"
                  >
                    <label class="w-100 text-gray text-left">Gender</label>
                    <select
                      class="form-control"
                      id="genderselection"
                      name="gender"
                      v-model.lazy="model.gender"
                      required
                    >
                      <option
                        v-for="genderType in genderArr.data.data.entries"
                        :key="genderType.id"
                        :value="genderType.id == 848 ? '' : genderType.id"
                        >{{ genderType.value.en_US }}</option
                      >
                    </select>

                    <field-messages
                      name="gender"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Gender is a required field
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.nationality)"
                  >
                    <label class="w-100 text-gray text-left">Nationality</label>
                    <select
                      class="form-control"
                      id="nationalityselection"
                      name="nationality"
                      v-model.lazy="model.nationality"
                      required
                    >
                      <option
                        v-for="nationalityType in nationalityArr.data.data
                          .entries"
                        :key="nationalityType.id"
                        :value="
                          nationalityType.id == 851 ? '' : nationalityType.id
                        "
                        >{{ nationalityType.value.en_US }}</option
                      >
                    </select>

                    <field-messages
                      name="nationality"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Nationality is a required field
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.email)"
                  >
                    <label class="w-100 text-gray text-left">Email</label>
                    <input
                      type="email"
                      name="email"
                      class="form-control"
                      required
                      v-model.lazy="model.email"
                    />

                    <field-messages
                      name="email"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Email is a required field
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.username)"
                  >
                    <label class="w-100 text-gray text-left">Username</label>
                    <input
                      type="text"
                      name="username"
                      class="form-control"
                      required
                      v-model.lazy="model.username"
                    />

                    <field-messages
                      name="username"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Username is a required field
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.password)"
                  >
                    <label class="w-100 text-gray text-left">Password</label>
                    <input
                      type="password"
                      name="password"
                      class="form-control"
                      required
                      v-model.lazy="model.password"
                    />

                    <field-messages
                      auto-label
                      name="password"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Password is a required field
                      </div>
                      <div slot="password" class="error">
                        Password is invalid
                      </div>
                    </field-messages>
                  </validate>

                  <div class="w-100 d-flex justify-content-start flex-column">
                    <div class="form-check text-left">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="model.termsCheckbox"
                        id="defaultCheck1"
                      />
                      <label
                        class="form-check-label d-flex flex-row align-items-center"
                        for="defaultCheck1"
                      >
                        <span class="w-100 d-flex flex-row text-white"
                          >Yes, I agree to
                          <router-link class="ml-2" :to="'/terms/'"
                            >terms of use</router-link
                          ></span
                        >
                      </label>
                    </div>
                    <div class="form-check text-left my-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="defaultCheck1"
                        v-model="model.marketingEmailCheckbox"
                      />
                      <label
                        class="form-check-label text-white"
                        for="defaultCheck1"
                      >
                        Yes I'm happy to receive marketing emails
                      </label>
                    </div>
                  </div>

                  <div class="py-2 text-center">
                    <button class="modal-default-button" type="submit">
                      Submit
                    </button>
                  </div>
                  <div class="w-100 my-2 error" v-if="errorMsg">
                    {{ errorMsg }}
                  </div>
                  <div class="w-100 my-2 success" v-if="successMsg">
                    {{ successMsg }}
                  </div>
                </vue-form>
                <div class="w-100 mt-3">
                  <router-link
                    class=""
                    :to="code ? `/login/${code}` : '/login'"
                  >
                    <div class="w-100 d-flex flex-row justify-content-center">
                      <span class="ml-2 signup-text">Already a member?</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
import axios from "axios";
export default {
  components: {
    BreadCrumbsHeader,
  },
  data() {
    return {
      formstate: {},
      model: {
        name: "",
        email: "",
        username: "",
        password: "",
        nationality: "",
        gender: "",
        termsCheckbox: false,
        marketingEmailCheckbox: false,
      },
      errorMsg: "",
      successMsg: "",
      genderArr: [],
      nationalityArr: [],
      code: this.$route.params.code,
    };
  },
  methods: {
    fieldClassName(field) {
      if (!field) {
        return "";
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return "has-success";
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return "has-danger";
      }
    },
    async onSubmit(e) {
      e.preventDefault();

      if (
        this.model.name &&
        this.model.email &&
        this.model.username &&
        this.model.password &&
        this.model.nationality &&
        this.model.gender
      ) {
        try {
          let res = await axios.post("https://rtb.glueapi.io/v1/user", {
            status: "active",
            name: this.model.name,
            email: this.model.email,
            username: this.model.username,
            password: this.model.password,
            data: {
              gender: this.model.gender,
              nationality: this.model.nationality,
            },
            agreedToTerms: this.model.termsCheckbox,
            agreedToMarketing: this.model.marketingEmailCheckbox,
          });
          this.errorMsg = "";
          let data = res.data;
          this.successMsg =
            "Registration Successful! Please login to access your account!";
          return data;
        } catch (error) {
          console.log(error.response); // this is the main part. Use the response property from the error object
          this.errorMsg = error.response.data.ResponseStatus.Message;
          this.successMsg = "";
          return error.response;
        }
      }
    },
  },
  async created() {
    this.genderArr = await axios.get(
      "https://rtb.glueapi.io/v1/content-list/12",
      {
        responseType: "json",
      }
    );
    this.nationalityArr = await axios.get(
      "https://rtb.glueapi.io/v1/content-list/11",
      {
        responseType: "json",
      }
    );
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 90px 0 0;
  min-height: 80vh;
  font-family: "Poppins", sans-serif !important;
}
.breadCrumbsWrapper {
  padding: 30px;
}
.modal-text {
  margin-top: 0;
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  color: #fab900;
}
.signup-text {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  color: #fab900;
}
.login-wrapper {
  width: 100%;
  max-width: 480px;
  background: #191919;
  border-radius: 4px;
}
.text-yellow {
  color: #f1c40f;
}
.text-black {
  color: black;
}
.text-gray {
  color: #6c757d;
}
.form-label {
  display: block;
  margin-bottom: 1em;
  font-size: 16px;
  color: black;
  text-align: left;
}
.form-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;
  color: #fab900;
}
.form-control:focus {
  color: #7a7e83;
  background-color: #191919;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}
.form-label > .form-control {
  margin-top: 0.5em;
}
.form-group label {
  text-align: left;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.5em 1em;
  line-height: 1.5;
  border: none;
  border-bottom: 1px solid #707070;
  border-radius: unset;
  background: #191919;
}
.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
  padding-top: 4px;
}
.error {
  color: red;
  font-size: 16px;
  margin-top: 4px;
}
.success {
  color: green;
  font-size: 16px;
  margin-top: 4px;
}
.modal-default-button {
  background: #f1c40f;
  color: #000000;
  border-radius: 4px;
  padding: 10px 25px;
  border: none;
  outline: none;
}
@media screen and (max-width: 768px) {
  .pt-livetv {
    padding: 8px 0 0;
  }
  .breadCrumbsWrapper {
    padding: 16px;
  }
}
</style>
